import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Search } from '@/components/icons/Search';
import type { WorkspaceGlobalSearchBarResultKeyword } from '@/types';
import { cx } from '@trinity/chat-components';
import ClickContainer from './Results.ClickContainer';
import styles from './style/Results.Keyword.module.css';

export default function ResultsKeyword({ className, index, item, highlighted }: ResultsKeywordProps) {
  return (
    <ClickContainer index={index} item={item}>
      <div className={cx(styles.root, { [styles.highlighted]: highlighted }, className)}>
        <Search
          className={styles.icon}
          size={28} />
        <div className={styles.details}>
          <div className={styles.name}>{item.name}</div>
          <div className={styles.type}>View all</div>
        </div>
        {highlighted && (
          <div className={styles.return}>
            <KeyboardReturnIcon />
          </div>
        )}
      </div>
    </ClickContainer>
  );
}

export { ResultsKeyword };

type ResultsKeywordProps = {
  className?: string;
  index: number;
  item: WorkspaceGlobalSearchBarResultKeyword;
  highlighted?: boolean;
};